import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchGeneralUsers = createAsyncThunk("fetchGeneralUsers", async ({ page, limit, filters }) => {
	const params = new URLSearchParams({
		page,
		limit,
		keyword: filters?.keyword || "",
		role: filters?.role || "",
	});

	const response = await axiosHttp.get(`user/list?${params}`);
	return response.data.data;
});

const GeneralUsersSlice = createSlice({
	name: "GeneralUsersSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		total: 0,
		page: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchGeneralUsers.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchGeneralUsers.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.total = action.payload.total;
			state.page = action.payload.current_page;
		});
		builder.addCase(fetchGeneralUsers.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default GeneralUsersSlice.reducer;
